export default function Numpy_GettingStarted() {
  return <div>Numpy_GettingStarted Component</div>;
}
